export function generatePrerequisiteData(race, proficiencyLookup, abilityLookup, characterLevel, baseClassLookup, featLookup, classFeatureLookup) {
    return {
        race,
        proficiencyLookup,
        abilityLookup,
        characterLevel,
        baseClassLookup,
        featLookup,
        classFeatureLookup,
    };
}
